'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroContentNotAvailable = require('./NitroContentNotAvailable');

var _NitroContentNotAvailable2 = _interopRequireDefault(_NitroContentNotAvailable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroContentNotAvailable2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-content-not-available/index.js
// module id = 54
// module chunks = 4